export default __webpack_public_path__ + "static/media/security.96da46c6.PNG";